var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkFlows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9937 6.57862L11.8976 11.5104C11.824 11.5461 11.7433 11.565 11.6614 11.5657C11.5795 11.5663 11.4985 11.5487 11.4243 11.5141L1.12757 6.6839C0.736434 6.50039 0.741929 5.97225 1.13676 5.79597L11.2627 1.27591C11.332 1.24516 11.4069 1.22903 11.4827 1.22853C11.5586 1.22802 11.6337 1.24315 11.7034 1.27297L21.9701 5.69146C22.367 5.8623 22.3811 6.38918 21.9937 6.57862Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.44724,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39621 10.5234L0.988788 11.6302C0.791615 11.7591 0.714193 12.1793 0.926926 12.2805L11.078 16.8483C11.2281 16.9198 11.3919 16.9576 11.5581 16.9593C11.7243 16.9609 11.8888 16.9262 12.0402 16.8577L22.0169 12.406C22.2773 12.2881 22.2263 11.678 21.9941 11.5112L19.7579 10.5577",
    stroke: "#E5E7EB",
    strokeWidth: 1.44724,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39621 16.2383L0.988788 17.345C0.791615 17.4739 0.714193 17.894 0.926926 17.9953L11.078 22.5631C11.2281 22.6346 11.3919 22.6724 11.5581 22.674C11.7243 22.6756 11.8888 22.641 12.0402 22.5724L22.0169 18.1208C22.2773 18.0029 22.2263 17.3926 21.9941 17.2259L19.7579 16.2724",
    stroke: "#E5E7EB",
    strokeWidth: 1.44724,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9238,
    height: 22.8915,
    fill: "white",
    transform: "translate(0.0761719 0.505859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkFlows);
export default __webpack_public_path__ + "static/media/workFlows.307fa9a38e78fd911c4e8f2fcd4d529d.svg";
export { ForwardRef as ReactComponent };